import { checkColorDark } from "./theme/theme";

const Type = {
  basic: "0",
  success: "1",
  error: "2",
  info: "3",
  warning: "4",
};

const mapBgColor = {
  [Type.basic]: "#ffffff",
  [Type.success]: "#008000",
  [Type.error]: "#B22222",
  [Type.info]: "#00AAAA",
  [Type.warning]: "#FFD700",
};

const consoleLog = (type, scope, text, ...args) => {
  // eslint-disable-next-line no-console
  console.log(
    `%c${scope ? `[${scope}]` : ""} ${text}`,
    `background: ${mapBgColor[type]};
    color: ${checkColorDark(mapBgColor[type]) ? "white" : "black"};
    ${type === Type.basic ? "font-weight: bold;" : ""}
    `,
    ...args
  );
};

const makeConsoleLogFn = (type) => {
  return (scope, text, ...args) => {
    consoleLog(type, scope, text, ...args);
  };
};

export const consoleLogSuccess = makeConsoleLogFn(Type.success);
export const consoleLogError = makeConsoleLogFn(Type.error);
// export const consoleLogErrorWithTrace = (...args) => {
//   consoleLogError(...args);
//
//   console.groupCollapsed("Trace");
//   console.trace();
//   console.groupEnd();
// };
export const consoleLogWarning = makeConsoleLogFn(Type.warning);
export const consoleLogInfo = makeConsoleLogFn(Type.info);
export const consoleLogBasic = makeConsoleLogFn(Type.basic);
export const consoleLogGroup = (groupName, data) => {
  console.groupCollapsed(groupName);
  console.log(data);
  console.groupEnd();
};
